import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import ServiceRestServices from '../../services/service-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-symptom-check-share',
	templateUrl: './modal-symptom-check-share.component.html',
	imports: [ CommonModule, DatePipe, TranslatePipe, LoaderOverlayComponent, AvatarComponent, FormsModule ]
})
export class ModalSymptomCheckShareComponent implements OnInit {
	private restService: RestService = inject(RestService);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalSymptomCheckShareComponent>);
	private data = inject(MAT_DIALOG_DATA);

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.interview = this.vm.booking.interview;
		
		this.initialize();
		
		this.vm.share = this.share;
		this.vm.removeShare = this.removeShare;
		this.vm.close = this.close;
	}
	
	getActiveBookings() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.serviceRestServices.activeBookings({ forBusiness: false },
			(bookings) => {
				deferred.resolve(bookings);
			},
			(e) => {
				console.error(e);
				deferred.reject();
			}
		);
		
		return deferred.promise;
	}
	
	initialize() {
		this.getActiveBookings()
			.then((bookings) => {
				bookings.forEach((item) => {
					item.sharingStatus = this.getSharingStatus(item);
				});

				this.vm.bookings = bookings;
				this.vm.isInitialized = true;
			})
			.catch((e) => {
				console.error('Failed to initialize', e);
			});
	}
	
	getSharingStatus(theBooking) {
		if (!theBooking.interview || !theBooking.interview.localId) {
			return 'possible';
		} else if (theBooking.interview.localId === this.vm.interview.localId) {
			return 'exists';
		} else {
			return 'disabled';
		}
	}
	
	share(theBooking) {
		if (this.vm.isProcessing) return;
		this.vm.isProcessing = true;
		
		var data: any = {
			interviewId: this.vm.interview.localId,
			bookingId: theBooking.id,
			booking: this.angularHelperService.copy(theBooking),
		};
		
		this.restService.saveInterviewShare({ interviewId: data.interviewId, bookingId: data.bookingId }, data)
			.then((res) => {
				this.close();
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	removeShare(theBooking) {
		if (this.vm.isProcessing) return;
		this.vm.isProcessing = true;
		
		var data: any = {
			interviewId: this.vm.interview.localId,
			bookingId: theBooking.id,
		};
		
		this.restService.deleteInterviewShare(data)
			.then((res) => {
				this.close();
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	close() {
		this.dialogRef.close();
	}
	
}